(function () {
  var t = document.querySelector('[data-menu-toggle]');
  var n = document.querySelector('[data-nav]');
  if (t && n) {
    t.addEventListener('click', function () {
      var open = n.classList.toggle('is-open');
      t.setAttribute('aria-expanded', open);
    });
  }
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('#GalleryMain');
    g.querySelectorAll('[data-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        main.src = b.dataset.src;
        main.srcset = b.dataset.srcset || '';
        main.alt = b.dataset.alt || '';
        g.querySelectorAll('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === b); });
      });
    });
  });
  var vs = document.querySelector('[data-variant-select]');
  if (vs) {
    vs.addEventListener('change', function () {
      var o = vs.options[vs.selectedIndex];
      var p = document.querySelector('[data-price]');
      var btn = document.querySelector('[data-add]');
      if (p) p.textContent = o.dataset.price;
      if (btn) {
        var ok = o.dataset.available === 'true';
        btn.disabled = !ok;
        btn.textContent = ok ? 'Add to cart' : 'Sold out';
      }
      var u = new URL(window.location.href);
      u.searchParams.set('variant', o.value);
      history.replaceState({}, '', u);
    });
  }
  document.querySelectorAll('[data-autosubmit]').forEach(function (el) {
    el.addEventListener('change', function () { el.form.submit(); });
  });
  document.querySelectorAll('ins.adsbygoogle').forEach(function () {
    try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch (e) {}
  });
})();
